import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import store from "app/redux/store/store";
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import globalMU from "globalMU";
import { map } from "p-iteration";
import React, { useEffect, useRef, useState } from "react"
import { DadosPorItem } from "./DadosPorItem";
import { DisponibilidadeCapacidadeDeCarga } from "./DisponibilidadeCapacidadeDeCarga"
import { Situacao } from './Situacao'
import * as R from 'ramda'
import { confirmarNovaDataPrevistaCapacidadeDeCarga } from "app/use-cases/orcamento/confirmarNovaDataPrevistaCapacidadeDeCarga";
import { IdentificadorItem } from "app/types/IdentificadorItem";
import { Dict } from "app/utils/Dict";
import { ChaveAgrupamento } from "./ChaveAgrupamento";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";

export type DisponibilidadeCapacidadeCargaContainerProps = {
    dadosValidacao: {
        IdentificadorItem: number
        SituacaoValidacaoCapacidadeCarga: Situacao
    }[]
    codigoRoteiro: string
    onDatasConfirmadas: () => void
}

export const DisponibilidadeCapacidadeCargaContainer = (props: DisponibilidadeCapacidadeCargaContainerProps) => {

    const [datasPorItem, setDatasPorItem] = useState<{
        [key: number]: {
            backgroundcolor: "red" | "green" | "blue",
            data: DataFormatoPT
        }[]
    }>({})

    const isMounted = useRef(true)
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "CHAVE_MOVIMENTACAO_ORCAMENTO"
                    ,"DEFINIR_PREVISAO_ENTREGA_POR_ITEM", // 486511 - parametro geral
                ]
            })
        )
       if (isMounted.current)
            setParametrosCarregados(true)
    }

    const valorParametro = (nome: string) => parametros.find(p => p.Nome == nome)?.Valor

    useEffect(() => {
        atualizarParametros()
        return () => {
            isMounted.current = false
        }
    }, [])

    const orcamento = useAppSelector(state => state.orcamento)

    const atualizarDatasPorItem = async ({
        dataReferencia
    }: {
        dataReferencia?: DataFormatoEN
    } = {}) => {
        if (!isMounted.current)
            return
        try {

            globalMU.blockUI()

            const buscarDadosDeDatasParaCalendario = async ({
                codigoFilial, codigoRoteiro, idTipoFrete, dataReferencia
            }: {
                codigoFilial: string
                codigoRoteiro: string
                idTipoFrete: number
                dataReferencia: DataFormatoEN
            }) => {
                if (!isMounted.current)
                    return []
                return await microuniversoApi.Orcamento.CalendarioCapacidadeCarga(
                    orcamento.IdentificadorOrcamento,
                    idTipoFrete,
                    codigoFilial,
                    codigoRoteiro,
                    dataReferencia ?? globalMU.converterObjetoDateParaDataFormatoEN(new Date())
                )
            }
            if (!isMounted.current)
                        return
            const agruparItens = () => {
                return (orcamento.ItensOrcamento ?? []).filter(i => i.CodigoTipoEntrega == "F").reduce((dict, item) => {

                    const chave: ChaveAgrupamento = {
                        codigoFilial: item.FilialParaCapacidadeDeCarga,
                        dataPrevista: globalMU.converterDataFormatoENParaPT(item.DataPrevisaoEntrega),
                        tipoFrete: {
                            id: item.IdTipoFrete,
                            nome: item.NomeTipoFrete
                        }

                    }

                    if (dict.has(chave)) {
                        dict.get(chave).push(item.Identificador)
                    } else {
                        dict.set(chave, [item.Identificador])
                    }

                    return dict

                }, new Dict<ChaveAgrupamento, IdentificadorItem[]>())
            }
            if (!isMounted.current) return
            const itensAgrupados = agruparItens()
            if (!isMounted.current) return
            const listaChavesEDatas = await map(itensAgrupados.keys(), async chave => ({
                chave,
                datas: await buscarDadosDeDatasParaCalendario({
                    codigoFilial: chave.codigoFilial,
                    codigoRoteiro: props.codigoRoteiro,
                    dataReferencia,
                    idTipoFrete: chave.tipoFrete?.id
                })
            }))
            if (!isMounted.current) return
            const obterDatasPorItem = () => {
                let datasPorItemMap: {
                    [key: IdentificadorItem]: {
                        backgroundcolor: "red" | "green" | "blue",
                        data: DataFormatoPT
                    }[]
                } = {}

                for (let chavesEDatas of listaChavesEDatas) {
                    const identificadoresItens = itensAgrupados.get(chavesEDatas.chave)

                    for (let identificadorItem of identificadoresItens) {
                        datasPorItemMap[identificadorItem] = chavesEDatas.datas
                    }
                }

                return datasPorItemMap
            }
            if (!isMounted.current) return
            const datasPorItemMap = obterDatasPorItem()
            if (!isMounted.current) return
            setDatasPorItem(datasPorItemMap)
        }
        catch (e) {
            
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const confirmarNovasDatas = async (datasPorItem: {
        [key: IdentificadorItem]: {
            novaDataPrevista: DataFormatoPT
            filial: string
        }
    }) => {
        
        if (!isMounted.current) return
        const agruparIdentificadoresItensPorDataEFilial = (): { [key: string]: IdentificadorItem[] } => {
            const m: { [key: string]: IdentificadorItem[] } = {}

            for (let identificadorItem of Object.keys(datasPorItem).map(Number)) {
                const key = JSON.stringify(datasPorItem[identificadorItem])

                if (key in m) {
                    m[key].push(identificadorItem)
                } else {
                    m[key] = [identificadorItem]
                }

            }

            return m
        }

        try {

            let ultimaData = "" // 485611
            if (!isMounted.current) return
            globalMU.blockUI()
            if (!isMounted.current) return
            const dadosAgrupados = agruparIdentificadoresItensPorDataEFilial()
            if (!isMounted.current) return
            for (let keyStr of Object.keys(dadosAgrupados)) {

                const key: {
                    filial: string
                    novaDataPrevista: DataFormatoPT
                } = JSON.parse(keyStr)

                const identificadoresItens = dadosAgrupados[keyStr]
                try
                {
                await confirmarNovaDataPrevistaCapacidadeDeCarga({
                    filial: key.filial,
                    identificadoresItens: identificadoresItens,
                    novaDataPrevista: globalMU.converterDataFormatoPTParaEN(key.novaDataPrevista)
                })
                }
                catch (e) {

                         //globalMU.showErrorMessage(e.message ?? "Ocorreu um erro ao confirmar nova data prevista para capacidade de carga.")
                         return
                    }


                ultimaData = key.novaDataPrevista // 485611
            }
            if (!isMounted.current) return

            await atualizarDatasPorItem()
            if (!isMounted.current) return
            props.onDatasConfirmadas()

            if (!isMounted.current) return

            if (ultimaData != "" && valorParametro("DEFINIR_PREVISAO_ENTREGA_POR_ITEM") != "S" ){ // 485611
                globalMU.showSuccessMessage(`Previsão de entrega do pedido alterada para [${ultimaData}]`) // 485611
            }
        } finally {
            globalMU.unblockUI()
        }
    }



    const ordenarItens = (itens: IItemOrcamento[]) => {
        const converterParaNumeroOuObterZero = (valor: string | number) => {

            const n = typeof (valor) == 'number' ? valor : Number(valor)

            return !isNaN(n) ? n : 0
        }
        if (!isMounted.current) return
        const comparar = (item1: IItemOrcamento, item2: IItemOrcamento): number => {
            const situacaoItem1 = props.dadosValidacao.find(i => i.IdentificadorItem == item1.Identificador).SituacaoValidacaoCapacidadeCarga
            const situacaoItem2 = props.dadosValidacao.find(i => i.IdentificadorItem == item2.Identificador).SituacaoValidacaoCapacidadeCarga
            const ordemItem1 = converterParaNumeroOuObterZero(item1.OrdemItem)
            const ordemItem2 = converterParaNumeroOuObterZero(item2.OrdemItem)

            if (situacaoItem1 == "CAPACIDADE_CARGA_OK" && situacaoItem2 != "CAPACIDADE_CARGA_OK") {
                return -1
            }

            if (situacaoItem2 == "CAPACIDADE_CARGA_OK" && situacaoItem1 != "CAPACIDADE_CARGA_OK") {
                return 1
            }

            return ordemItem1 - ordemItem2
        }

        return R.sort(comparar, itens)
    }

    const obterItens = () => {
        if (!isMounted.current) return
        return R.pipe(
            itens => itens.filter(i => i.CodigoTipoEntrega == "F" && props.dadosValidacao.map(a => a.IdentificadorItem).includes(i.Identificador)),
            ordenarItens
        )((store.getState().orcamento.ItensOrcamento ?? []))
    }

    useEffect(() => {
        if (!isMounted.current) return
        atualizarDatasPorItem({})
    }, [])

    return <>
        {parametrosCarregados && <DisponibilidadeCapacidadeDeCarga
            itens={obterItens().map(item => ({
                descricao: item.Descricao,

                identificador: item.Identificador,

                situacao: props.dadosValidacao.find(i => i.IdentificadorItem == item.Identificador)?.SituacaoValidacaoCapacidadeCarga,

                dataPrevista: item.DataPrevisaoEntrega ? globalMU.converterDataFormatoENParaPT(item.DataPrevisaoEntrega) : !item.DataMarcadaEntrega ? globalMU.formatDate(orcamento.DataPrevisaoEntrega) : null,
                dataMarcada: item.DataMarcadaEntrega ? globalMU.converterDataFormatoENParaPT(item.DataMarcadaEntrega) : !item.DataPrevisaoEntrega ? orcamento.DataMarcadaEntrega : null,

                datas: (datasPorItem[item.Identificador] ?? []).map(d => ({
                    data: d.data,
                    situacao: d.backgroundcolor == "red" ? "INDISPONIVEL" :
                        d.backgroundcolor == "blue" ? "DISPONIVEL" :
                            d.backgroundcolor == "green" ? "SEM_CADASTRO" : null
                } as DadosPorItem["datas"][0])),

                filial: item.FilialParaCapacidadeDeCarga,
                tipoFrete: {
                    id: item.IdTipoFrete,
                    nome: item.NomeTipoFrete
                },

                identificacaoProduto: valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? "CODIGO" : "REFERENCIA",
                codigoOuReferencia: valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? item.CodigoProduto : item.ReferenciaProduto

            } as DadosPorItem))}

            roteiro={orcamento.Transportadora?.CodigoRoteiroEntrega ?? ""}

            onConfirmarNovasDatas={confirmarNovasDatas}

            onAtualizarCalendarioPorItemOrcamento={dataReferencia => {
                atualizarDatasPorItem({
                    dataReferencia: globalMU.converterObjetoDateParaDataFormatoEN(dataReferencia)
                })
            }}
            onAtualizarCalendarioPorItensAgrupados={dataReferencia => {
                atualizarDatasPorItem({
                    dataReferencia: globalMU.converterObjetoDateParaDataFormatoEN(dataReferencia)
                })
            }}
            tipoExibicao={ valorParametro("DEFINIR_PREVISAO_ENTREGA_POR_ITEM") == "S" ? "ITEM_A_ITEM" : "AGRUPADO"} // 485611 - se nao for item a item, o padrao deve ser agrupado porque todos os itens devem ter mesma data
        />}
    </>
}